import React, { useState } from "react";
import { SectionContainer, SectionContent } from "./styles.js";

import chevronDown from "./img/chevron-down-white.svg";
import chevronUp from "./img/chevron-up-white.svg";
import chevronDownBlack from "./img/chevron-down-black.svg";
import chevronUpBlack from "./img/chevron-up-black.svg";

const ExpandingContainer = ({ title, children, customColor, titleColor }) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <SectionContainer customColor={customColor}>
      <div className="title-bar" onClick={() => setExpanded(!expanded)}>
        <h2 style={{ color: titleColor }}>{title}</h2>
        <img
          src={
            expanded
              ? customColor === "#fff"
                ? chevronUpBlack
                : chevronUp
              : customColor === "#fff"
              ? chevronDownBlack
              : chevronDown
          }
          alt={`chevron ${expanded ? "up" : "down"}`}
        />
      </div>

      {expanded && <SectionContent>{children}</SectionContent>}
    </SectionContainer>
  );
};

export default ExpandingContainer;
